var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isConverted)?_c('BaseTooltip',{attrs:{"label":_vm.conversionDescription,"is-small":"","allow-line-breaks":"","dashed":"","append-to-body":""}},[_c('span',[_vm._v("\n        "+_vm._s(_vm.amount)+"\n    ")])]):_c('span',[_vm._v("\n    "+_vm._s(_vm.amount)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }